import React, { ComponentPropsWithoutRef, FocusEvent } from "react";

interface Props extends ComponentPropsWithoutRef<"div"> {}

/**
 * Container that triggers onBlur only if focus is outside
 * Helps keep stuff intact whenever focus jumps between children
 * @param props HTML Div props with onFocus and on Blur
 */
export const FocusAware = (props: Props) => {
  const handleBlur = (e: FocusEvent<HTMLDivElement>) => {
    const focusOutside = !e.currentTarget.contains(e.relatedTarget as Node | null);
    if (focusOutside) {
      props.onBlur?.(e);
    }
  };

  return (
    <div {...props} onBlur={handleBlur}>
      {props.children}
    </div>
  );
};
